import React, { Component, ComponentType } from 'react'
import { NavLink } from 'react-router-dom'

export interface WithLinkProps {
  internalLink: string | null
  externalLink: string | null
}

export const WithLink = <P extends object>(
  WrappedComponent: ComponentType<P>
) => {
  return class WithLink extends Component<P & WithLinkProps> {
    render() {
      const { internalLink, externalLink, ...props } = this.props
      return (
        <div>
          {internalLink && (
            <NavLink to={internalLink}>
              <WrappedComponent {...(props as P)} />
            </NavLink>
          )}
          {externalLink && (
            <a href={externalLink}>
              <WrappedComponent {...(props as P)} />
            </a>
          )}
          {!internalLink && !externalLink && (
            <WrappedComponent {...(props as P)} />
          )}
        </div>
      )
    }
  }
}

WithLink.displayName = 'WithLink'
